<script>
  import { Router, Route } from "svelte-routing";

  import { authToken } from "../stores.js";

  import SideBar from "components/Sidebar.svelte";

  import Main from "./main/Index.svelte";
  import Document from "./document/Index.svelte";
  import Lawcase from "./lawcase/Index.svelte";
  import Folder from "./folder/Index.svelte";
  import PersonalData from "./personalData/Index.svelte";
  import ActivityLogs from "./activityLogs/Index.svelte";
  import Settings from "./settings/Index.svelte";
  import NotFound from "./NotFound.svelte";

  // Helper components
  import Layout from "components/Layout.svelte";

  const logout = () => {
    authToken.set(null);
    localStorage.setItem("client-token", null);
    window.location.href = "/logout";
  };
</script>

<Router>
  <Route path="/lawcase/:lawcaseId/document/:documentId" let:params>
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <Document {...params} />
      </div>
    </Layout>
  </Route>
  <Route path="/lawcase/:lawcaseId/folder/:folderId" let:params>
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <Folder {...params} />
      </div>
    </Layout>
  </Route>
  <Route path="/lawcase/:lawcaseId/*subpages" let:params>
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <Lawcase {...params} />
      </div>
    </Layout>
  </Route>
  <Route path="/activities">
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <ActivityLogs />
      </div>
    </Layout>
  </Route>
  <Route path="/personal">
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <PersonalData />
      </div>
    </Layout>
  </Route>
  <Route path="/settings">
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <Settings />
      </div>
    </Layout>
  </Route>
  <Route path="/">
    <Layout {logout}>
      <div slot="sidebar">
        <SideBar on:click={logout} />
      </div>
      <div slot="main">
        <Main />
      </div>
    </Layout>
  </Route>
  <Route path="/*path" component={NotFound} />
</Router>
